import { ReactNode } from "react";
import { AppId, FCX, ProductLogo } from "@datassential/platform-ui-lib";
import Page from "@containers/Page/Page";
import PageContent from "@containers/PageContent/PageContent";
import { CustomBaseScrollbars } from "@components/CustomScrollbarsVirtualList/CustomScrollbarsVirtualList";
import ScrollTopButton from "@pages/Food/components/ScrollToTop/ScrollToTop";
import { FOOD_PAGE_SCROLLBAR_ID } from "@pages/Food/Food.constants";

interface Props {
    /** Root class of the page version (`Food`, `FoodRefresh`); the wrapper gets `<rootClassName>__wrapper`. */
    rootClassName: string;
    isLoading: boolean;
    /** Full-width page header above the centred wrapper, shown while the page loads too. */
    header?: ReactNode;
    children: ReactNode;
}

/** Page chrome shared by both Food Profile versions: scroll container, loading spinner, scroll-to-top button. */
const FoodProfilePageFrame: FCX<Props> = ({ rootClassName, isLoading, header, children }) => (
    /* @ts-ignore */
    <Page>
        <PageContent>
            <CustomBaseScrollbars id={FOOD_PAGE_SCROLLBAR_ID}>
                <div className={rootClassName}>
                    {header}
                    <div className={`${rootClassName}__wrapper`}>
                        {isLoading && (
                            <div className="spinner spinner-blink">
                                <ProductLogo appId={AppId.Snap} type="regular"/>
                            </div>
                        )}
                        {!isLoading && children}
                    </div>
                </div>
            </CustomBaseScrollbars>
            <ScrollTopButton
                scrollElementId={FOOD_PAGE_SCROLLBAR_ID}
                testId="buttonFoodScrollToTop"
            />
        </PageContent>
    </Page>
);

export default FoodProfilePageFrame;
